import { EN_COMUNE } from './comune';
import { EN_SERVER } from './server';
import { EN_ISTANZE } from './istanze';
import { EN_CONTINUITA } from './continuita';
import { EN_ORGANIZZAZIONE } from './organizzazione';
import { EN_BLUEPRINT } from './blueprint';
import { EN_ACCESSI } from './accessi';

/**
 * Il dizionario inglese, diviso per aree del pannello solo per comodità di chi
 * lo scrive: la stessa frase italiana ha una sola traduzione, ovunque compaia.
 */
export const EN: Record<string, string> = {
  ...EN_COMUNE,
  ...EN_SERVER,
  ...EN_ISTANZE,
  ...EN_CONTINUITA,
  ...EN_ORGANIZZAZIONE,
  ...EN_BLUEPRINT,
  ...EN_ACCESSI,
};
